/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addScalarDependencies } from './dependenciesAddScalar.generated.js';
import { dotDependencies } from './dependenciesDot.generated.js';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createMultiply } from '../../factoriesAny.js';
export var multiplyDependencies = {
  addScalarDependencies,
  dotDependencies,
  equalScalarDependencies,
  matrixDependencies,
  multiplyScalarDependencies,
  typedDependencies,
  createMultiply
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesMultiply.generated.js
// module id = kKer
// module chunks = 3